module.exports = __webpack_public_path__ + "img/ellipser.24c0996a.png";